import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Volume 2 icon for audio/sound enabled
 */
export const Volume2Icon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
    </Icon>
  );
};

export default Volume2Icon;
